<script>
export default {
    data() {
      return {
        count: 0
      }
    },
    props: ['order']
  }
  </script>
  
  <template>
      <span class="" style="margin-left:5px">
        <div class="tag is-success" v-if="order.fully_printed == 1">F/P</div>
        <div class="tag is-link" v-if="order.part_printed == 1">P/P</div>
        <div class="tag is-warning" v-if="order.cut_sew == 1">C/S</div>
      </span>
  </template>